module.exports = __webpack_public_path__ + "img/create-3.6ec3a6f4.png";